// Frontend-only localization of backend error messages.
// The backend returns English `detail` strings; this maps the known ones to
// i18n keys by HTTP status + exact wording so toasts follow the UI language.
// Unknown messages are shown exactly as the backend sent them (previous behaviour).
// No backend/API change is involved.

const RULES = [
  { status: 402, re: /^Free plan limit reached \((\d+) receipts\)/, key: "err.freeLimitScans" },
  { status: 402, re: /^Free plan limit reached \((\d+) subscriptions\)/, key: "err.freeLimitSubs" },
  { status: 400, re: /^Empty file$/, key: "err.emptyFile" },
  { status: 413, re: /^Image too large \(max (\d+)MB\)/, key: "err.imageTooLarge" },
  { status: 422, re: /^Could not read receipt/, key: "err.couldNotRead" },
  { status: 404, re: /^Receipt not found$/, key: "err.receiptNotFound" },
  { status: 404, re: /^Subscription not found$/, key: "err.subNotFound" },
];

export function localizeApiError(e, t, fallbackKey) {
  const status = e?.response?.status;
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string" && detail) {
    for (const r of RULES) {
      if (r.status !== status) continue;
      const m = detail.match(r.re);
      if (m) return t(r.key, { n: m[1] });
    }
    return detail;
  }
  return t(fallbackKey);
}
